import min from 'lodash/min'
import now from 'lodash/now'

export const VIDEO_FILETYPES = 'video/mp4'
export const IMAGE_FILETYPES = 'image/jpeg,image/png,image/svg+xml'

const QUALITY = 100 / 100

// iphone 7 Plus resolution
const MIN_WIDTH = 1080
const MIN_HEIGHT = 1920
/**
 * Optimize image file befor upload
 */
function optimizeImage (image, imageFile) {
  // console.log('optimizeImage', imageFile)
  let canResize = image.naturalWidth > MIN_WIDTH && image.naturalHeight > MIN_HEIGHT
  // console.log('optimizeImage, naturalWidth', image.naturalWidth, 'naturalHeight', image.naturalHeight)
  // console.log('optimizeImage, canResize', canResize)
  if (canResize) {
    const kWidth = image.naturalWidth / MIN_WIDTH
    const kHeight = image.naturalHeight / MIN_HEIGHT
    const k = min([kWidth, kHeight])
    // console.log('kWidth', kWidth, 'kHeight', kHeight, 'k', k)
    const canvas = document.createElement('canvas')
    canvas.width = image.naturalWidth / k
    canvas.height = image.naturalHeight / k
    canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height)
    const newImageSrc = canvas.toDataURL(imageFile.type, QUALITY)
    const newImageFile = dataURItoBlob(newImageSrc, imageFile.name)
    newImageFile.name = imageFile.name
    newImageFile.width = canvas.width
    newImageFile.height = canvas.height
    // console.log('optimizeImage, resized', newImageFile)
    return newImageFile
  } else {
    return imageFile
  }
}

/**
 * Utility functions to process image file uploading
 */
export function processImage (imageFile) {
  return new Promise((resolve, reject) => {
    const src = window.URL.createObjectURL(imageFile)

    const image = new Image()
    image.src = src

    image.addEventListener('load', () => {
      const imageFileToUpload = optimizeImage(image, imageFile)
      const width = image.naturalWidth
      const height = image.naturalHeight

      if (width >= height) {
        imageFileToUpload.wrongAR = true
        resolve(imageFileToUpload)
      } else {
        resolve(imageFileToUpload)
      }
    })

    image.addEventListener('error', () => {
      reject(new Error('Image optimize error'))
    })
  })
}

/*
 * Convert base64/URLEncoded data component to raw binary data held in a string
 */
export function dataURItoBlob (dataURI) {
  let byteString
  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1])
  } else {
    byteString = unescape(dataURI.split(',')[1])
  }
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  const blob = new Blob([ia], {type: mimeString})
  blob.lastModifiedDate = now()
  return blob
}

/**
 * Provide DOM node for video processing.
 * It removes all child in case if node is not empty.
 */
function getDomNodeForVideoProcessing () {
  let node = document.getElementById('for-video-processing')

  if (!node) {
    node = document.createElement('div')
    node.id = 'for-video-processing'
    node.style.position = 'absolute'
    node.style.top = '-5000px'
    document.getElementsByTagName('body')[0].appendChild(node)
  } else {
    while (node.firstChild) { // ensure that dom node is empty
      node.removeChild(node.firstChild)
    }
  }

  return node
}

/**
 * Utility functions to process video file uploading
 */
export function processVideo (videoFile) {
  return new Promise((resolve, reject) => {
    const src = window.URL.createObjectURL(videoFile)

    const node = getDomNodeForVideoProcessing()
    const video = document.createElement('video')
    node.appendChild(video)

    video.src = src
    video.currentTime = 0.1
    video.addEventListener('seeked', () => {
      const canvas = document.createElement('canvas')
      canvas.width = video.offsetWidth
      canvas.height = video.offsetHeight
      canvas.getContext('2d').drawImage(video, 0, 0, video.offsetWidth, video.offsetHeight)

      const src = canvas.toDataURL('image/png', QUALITY)
      const imageFile = dataURItoBlob(src, videoFile.name)
      videoFile.width = video.offsetWidth
      videoFile.height = video.offsetHeight

      resolve({videoFile, imageFile})
    })

    video.addEventListener('error', () => {
      reject(new Error('Video optimize error'))
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/uploadUtils.js